import { render, staticRenderFns } from "./destroyRecord.vue?vue&type=template&id=4de3aed6"
import script from "./destroyRecord.vue?vue&type=script&lang=js"
export * from "./destroyRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports